import { OshFocusKPI, RmsFocusKPI } from "@/types/ApiTypes";
import { ByzzerSelectOption } from "@byzzer/ui-components";

export const focusKPIOptions: ByzzerSelectOption<{
    suffixDisplay?: string;
}, RmsFocusKPI>[] = [
    { display: 'Dollar Sales', value: 'Dollar Sales', data: {
        suffixDisplay: ''
    } },
    { display: 'Unit Sales', value: 'Unit Sales', data: {
        suffixDisplay: 'units'
    } },
    { display: 'EQ Units', value: 'EQ Units', data: {
        suffixDisplay: 'EQ units'
    } },
];

export const omniShopperFocusKPIOptions: ByzzerSelectOption<{
    suffixDisplay?: string;
}, OshFocusKPI>[] = [
    {
        display: 'Value (Dollar volume)',
        value: 'Value (Dollar volume)',
        data: {
            suffixDisplay: '',
        },
    },
    {
        display: 'Units',
        value: 'Units',
        data: {
            suffixDisplay: 'units',
        },
    },
];
